{
  "version": 1,
  "asset_id": "d304b01f-19a3-4bff-97c3-8d38a354483f",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/d304b01f-19a3-4bff-97c3-8d38a354483f/ctp.webp",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/d304b01f-19a3-4bff-97c3-8d38a354483f/ctp.webp",
  "original_filename": "ctp.webp",
  "size": 8442,
  "content_type": "image/webp",
  "created_at": "2026-06-26T16:55:06Z"
}
